import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';
import applicationStore from '@services/stores/ApplicationStore';
import { ShopwareProduct } from '@services/types/Shopware';

const useStyles = makeStyles(() => ({
}), { name: 'ProductTooling' });

export default function ProductTooling(product: ShopwareProduct) {
    async function refresh() {
        applicationStore.getState().methods.notify('Skickat in förfrågan!');
        await fetch('https://interstellar' + '.newport.' + 'se/api/utility/cache-manager/web/purge-product-images', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify({
                urls: [
                    `https://cdn-images.newporthome.eu/product/${(product.id)}/list-45/list.jpg`,
                    `https://cdn-images.newporthome.eu/product/${(product.id)}/list-45-environment/list.jpg`
                ],
            }),
        });
        applicationStore.getState().methods.notify(null, {
            components: <b>{product.productNumber} uppdaterad!</b>
        });
    }

    return (
        <>
            <Button href={`https://interstellar.newport.se/products/${(product.productNumber)}`} target={'_blank'}>Go to product</Button>
            <Button onClick={refresh}>Refresh image</Button>
        </>
    );
}
